import { dataLowSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLowSquareSolid = /*#__PURE__*/createIcon(dataLowSquareSolid)
export default IconLowSquareSolid
